import React from "react";
import type { ICheckboxProps } from "@fluentui/react/lib/Checkbox";
/* eslint-disable-next-line @fluentui/react-components/prefer-fluentui-v9 -- (https://aka.ms/OWALintWiki)
 * Baseline. DO NOT COPY AND PASTE! Substitute this line with an explanation or resolve the problem by using v9 components instead
 *	> Avoid importing Checkbox from '@fluentui/react', as this package has started migration to Fluent UI 9. Import Checkbox from '@fluentui/react-components' instead. */
import { Checkbox } from "@fluentui/react/lib/Checkbox";
import { checkboxStylesOverride, checkmarkStyles, squareCheckbox, selectedMessageCheckboxStyle, indeterminateOrCheckedStyle, } from "./Checkbox.scss";

import { observer } from "owa-mobx-react";

import classnames from "owa-classnames";

export interface FluentCheckboxProps extends ICheckboxProps {
    isMessageSelected?: boolean;
    shouldOverrideCheckboxStyles?: boolean;
}

const FluentCheckbox: React.FunctionComponent<FluentCheckboxProps> = observer(function FluentCheckbox(props: FluentCheckboxProps) {
    const { checked, indeterminate, isMessageSelected, shouldOverrideCheckboxStyles } = props;
    
    const checkboxStyles = React.useMemo(() => ({
        ...props.styles,
        checkbox: classnames(squareCheckbox, shouldOverrideCheckboxStyles && checkboxStylesOverride, isMessageSelected && selectedMessageCheckboxStyle, (checked || indeterminate) && indeterminateOrCheckedStyle),
        checkmark: checkmarkStyles,
    }), [props.styles, isMessageSelected, checked, indeterminate, shouldOverrideCheckboxStyles]);
    
    return <Checkbox {...props} styles={checkboxStyles}/>;
}, "FluentCheckbox");
export default FluentCheckbox;
